/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import validationPartenaire from '../validationPartenaire';
import validationComplementInsee, {
  validationNombreEnfantsMax,
} from '../validationComplementInsee';

const validationStep4et6 = (
  PACS: any,
  numeroPartenaire: number,
  mode?: string | null,
) => {
  // Les informations INSEE ne sont pas obligatoires sur un projet de PACS
  // (hors plafond du nombre d'enfants en commun, saisi sur le partenaire 1).
  if (mode === 'projet') {
    const nombreEnfantsMax =
      numeroPartenaire === 1
        ? validationNombreEnfantsMax(PACS?.complementInsee?.nombreEnfants)
        : null;

    return {
      ...validationPartenaire(PACS, numeroPartenaire, true),
      ...(nombreEnfantsMax && { nombreEnfants: nombreEnfantsMax }),
    };
  }

  const prefix = `p${numeroPartenaire}`;
  const complementInsee = PACS?.complementInsee;

  return {
    ...validationPartenaire(PACS, numeroPartenaire),
    ...validationComplementInsee(
      {
        etatMatrimonialCode: complementInsee?.[`${prefix}EtatMatrimonialCode`],
        dateDivorce: complementInsee?.[`${prefix}DateDivorce`],
        dateVeuvage: complementInsee?.[`${prefix}DateVeuvage`],
        dejaPacse: complementInsee?.[`${prefix}DejaPacse`],
        nombreEnfants: complementInsee?.nombreEnfants,
      },
      numeroPartenaire === 1,
    ),
  };
};

export default validationStep4et6;
